import React from 'react';
import { ChevronLeft, ChevronRight, Clock3 } from 'lucide-react';

function formatFreshness(freshness) {
  if (!freshness?.lastSuccessfulSync) return 'Stale · Awaiting recorded sync';
  const date = new Date(freshness.lastSuccessfulSync);
  if (Number.isNaN(date.getTime())) return 'Sync time unavailable';
  const prefix = freshness.stale ? 'Stale · Last updated' : 'Updated';
  return `${prefix} ${date.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}`;
}

function LeaderboardFooter({ freshness, pagination, onPageChange, pageSize, onPageSizeChange, disabled }) {
  const page = pagination?.page || 1;
  const totalPages = Math.max(pagination?.totalPages || 1, 1);

  return (
    <footer className="leaderboard-footer">
      <div className={`freshness-status ${freshness?.stale ? 'is-stale' : ''}`}>
        <Clock3 size={16} aria-hidden="true" />
        <span>{formatFreshness(freshness)}</span>
        {freshness?.sourceBlockHeight && <span>Block {Number(freshness.sourceBlockHeight).toLocaleString()}</span>}
      </div>
      <div className="pagination-controls">
        <label className="page-size-control">
          <span>Rows</span>
          <select value={pageSize} onChange={(event) => onPageSizeChange(Number(event.target.value))} disabled={disabled}>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </label>
        <span className="page-count">Page {page.toLocaleString()} of {totalPages.toLocaleString()}</span>
        <button
          className="pagination-button"
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={disabled || page <= 1}
          title="Previous page"
          aria-label="Previous page"
        >
          <ChevronLeft size={19} aria-hidden="true" />
        </button>
        <button
          className="pagination-button"
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={disabled || page >= totalPages}
          title="Next page"
          aria-label="Next page"
        >
          <ChevronRight size={19} aria-hidden="true" />
        </button>
      </div>
    </footer>
  );
}

export default LeaderboardFooter;
